import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../api/api";

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f2f8fa",
    maxWidth: "900px",
    margin: "40px auto",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  heading: {
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#073642",
    padding: "15px",
    borderRadius: "8px",
    fontSize: "26px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginBottom: "20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  },
  field: {
    display: "block",
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  button: {
    padding: "12px 20px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#073642",
    color: "#fff",
    cursor: "pointer",
    width: "100%",
    fontSize: "16px",
  },
};

const CustomerComplaintForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    company: "",
    description: "",
    category: "",
    other_category: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.category === "others" && !formData.other_category.trim()) {
      toast.error("Please specify the category when selecting 'Others'");
      return;
    }

    try {
      await API.post("/tasks/complaints/", formData);
      toast.success("Complaint submitted");
      navigate("/confirm");
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Failed to submit. Please try again.");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Customer Complaint</h2>
      <form onSubmit={handleSubmit}>
        <input
          style={styles.field}
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          style={styles.field}
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
        />

        <input
          style={styles.field}
          type="text"
          name="contact"
          placeholder="Contact Number"
          value={formData.contact}
          onChange={handleChange}
        />

        <input
          style={styles.field}
          type="text"
          name="company"
          placeholder="Company"
          value={formData.company}
          onChange={handleChange}
        />

        <label style={styles.label}>Complaint Category</label>
        <select
          style={styles.field}
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
        >
          <option value="">-- Select a Category --</option>
          <option value="cctv">CCTV</option>
          <option value="home_automation">Home Automation</option>
          <option value="gate_barrier">Gate Barrier (Parking System)</option>
          <option value="access_control">Access Control (Bio Metric)</option>
          <option value="facade_lights">Facade Lights</option>
          <option value="motion_works">Motion Works</option>
          <option value="led">LED Outdoor or Indoor</option>
          <option value="structure_cable">Structure Cable</option>
          <option value="speakers">Speakers</option>
          <option value="it_amc">IT AMC Works</option>
          <option value="others">Others</option>
        </select>

        {formData.category === "others" && (
          <input
            style={styles.field}
            type="text"
            name="other_category"
            placeholder="Specify category"
            value={formData.other_category}
            onChange={handleChange}
            required
          />
        )}

        <textarea
          style={styles.field}
          name="description"
          placeholder="Complaint Description"
          rows={4}
          value={formData.description}
          onChange={handleChange}
          required
        ></textarea>

        <button style={styles.button} type="submit">
          Submit Complaint
        </button>
      </form>
    </div>
  );
};

export default CustomerComplaintForm;
